import config from "config";
import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function fetchExcessMoneySettlementsApi(params: FilterMetadata) {
    const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-money/settlements`;
    return api.get(`${baseUrl}`, params)
}

function fetchExcessMoneySettlementApi(params: any) {
    const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-money/settlement/${params?.id}`
    return api.get(`${baseUrl}`, params)
}

export { fetchExcessMoneySettlementApi, fetchExcessMoneySettlementsApi }